import {
    VenueAnalysisFillInfoElement,
    VenueAnalysisQtyInfoElement,
    VenueAnalysisOrderInfoElement,
    VenueAnalysisTimeElement,
} from 'widgets/venueAnalysis/api/VenueAnalysisElement';
import {
    VenueAnalysisFillInfoState,
    VenueAnalysisQtyInfoState,
    VenueAnalysisOrderInfoState,
    VenueAnalysisDataTimeSeriesItem,
} from './VenueAnalysisStreamDataState';
import omitUndefined from 'utils/omitUndefined';

export function mapFullInfoFromStream(
    element: VenueAnalysisFillInfoElement
): VenueAnalysisFillInfoState {
    return {
        buyFillQty: element.bf,
        sellFillQty: element.sf,
        buyRemainingQty: element.br,
        sellRemainingQty: element.sr,
        buyFillPrice: element.bp,
        sellFillPrice: element.sp,
    };
}

export function mapQtyInfoFromStream(
    element: VenueAnalysisQtyInfoElement
): VenueAnalysisQtyInfoState {
    return {
        buyOrderQty: element.bq,
        sellOrderQty: element.sq,
    };
}

export function mapOrderInfoFromStream(
    element: VenueAnalysisOrderInfoElement
): VenueAnalysisOrderInfoState {
    return {
        symbolDescription: element.n,
        symbol: element.s,
        arrivalTimeEpoch: element.a,
        tickSize: element.tickSize,
    };
}

export function mapToVenueAnalysisDataTimeSeriesItemFromElement(
    from: VenueAnalysisTimeElement
): VenueAnalysisDataTimeSeriesItem {
    return omitUndefined({
        _i: from._i,
        id: from._k,
        executionId: from.exec,
        orderId: from.oid,
        fillQty: from.sh,
        executionTime: from.t,
        executionPrice: from.price,
        executionBroker: from.dest,
        lastMkt: from.lastMkt,
        venueName: from.name,
        venueType: from.type,
        liquidityType: from.liq,
        buySideLiquidityCode: from.bsLiq,
        parentOrderSide: from.side,
        liquidityCode: from.lastLiqCode,
    });
}
